








import Vue from "vue";
import { Tag } from "@/model/data/Tag";

export default Vue.extend({
    props: {
        tag: Object as () => Tag,
    },
});
